import http from '../../utils/fetch';
export default {
    //分页查询用户单位关键字
    selectPage(query){
        return http({
            url: 'api/swyl/v1/basic/bscAddrKeywords/selectPage',
            method: 'post',
            params: query
        });
    },
    //分页查询用户单位关键字
    select2Page(query){
        return http({
            url: 'api/swyl/v1/basic/bscAddrKeywords/select2Page',
            method: 'post',
            params: query
        });
    },
    //单条查看
    selectById(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrKeywords/selectById?id='+query,
            method: 'post',
            params: query
        });
    },
    //删除
    deleteById(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrKeywords/deleteKeywords?id='+query,
            method: 'post',
            params: query
        });
    },
    //新增收货单位
    insertKeywords(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrKeywords/insertKeywords',
            method: 'post',
            params: query
        });
    },
    //根据用户单位匹配关键字
    matchKeywords(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrKeywords/matchKeywords?deptName='+query,
            method: 'post',
            params: query
        });
    },
    matchKeywords2(query) {
        return http({
            url: 'api/swyl/v1/basic/bscAddrKeywords/matchKeywords2?deptName='+query,
            method: 'post',
            params: query
        });
    },
}